import { CONFIGS } from '@buildwise/libs/configurations';
import {
  GetAdditionalFiltersOptions,
  useConfigFilters,
} from '@buildwise/libs/configurations/hooks';
import { FilterType } from 'components/common/filter/Filter';
import useUserData, { UserType } from 'hooks/useUserData';
import { useCallback } from 'react';

function usePeopleFilters({
  people,
  shouldFetch = true,
  mapFilters,
}: {
  people: UserType[];
  shouldFetch?: boolean;
  mapFilters?: (options: { filters: FilterType[] }) => FilterType[];
}) {
  const { companyId } = useUserData();
  const getAdditionalFilters = useCallback(
    ({ configFilters }: GetAdditionalFiltersOptions) =>
      mapFilters ? mapFilters({ filters: configFilters }) : configFilters,
    [],
  );
  const { filters, isFiltersLoading, clearFilters, setFilters } = useConfigFilters({
    companyId,
    configName: CONFIGS.USER_FILTERS.configName,
    data: people,
    showFiltersCount: true,
    shouldFetch,
    getAdditionalFilters,
  });

  return {
    filters,
    isFiltersLoading,
    clearFilters,
    setFilters,
  };
}

export default usePeopleFilters;
